/**
 * Business Card Tab Functionality with URL Hash
 */
(function (Drupal) {
  'use strict';

  Drupal.behaviors.businessCard = {
    attach: function (context) {
      const cards = context.querySelectorAll('.business-card');

      cards.forEach(card => {
        if (card.dataset.initialized) return;
        card.dataset.initialized = 'true';

        const tabs = card.querySelectorAll('.business-card__tab');
        const panels = card.querySelectorAll('.business-card__panel');

        const switchTab = (targetTab, updateHash = true) => {
          tabs.forEach(tab => {
            const isActive = tab.dataset.tab === targetTab;
            tab.classList.toggle('business-card__tab--active', isActive);
            tab.setAttribute('aria-selected', isActive);
          });

          panels.forEach(panel => {
            const isActive = panel.dataset.panel === targetTab;
            panel.classList.toggle('business-card__panel--active', isActive);
          });

          // Update URL hash
          if (updateHash) {
            const hash = targetTab === 'vcard' ? 'info' : 'qr';
            history.replaceState(null, null, '#' + hash);
          }
        };

        // Handle tab clicks
        tabs.forEach(tab => {
          tab.addEventListener('click', () => switchTab(tab.dataset.tab, true));
        });

        // Initialize from URL hash
        const hash = window.location.hash.substring(1);
        if (hash === 'info') {
          switchTab('vcard', false);
        } else if (hash === 'qr') {
          switchTab('qr', false);
        }

        // Handle browser back/forward
        window.addEventListener('hashchange', () => {
          const currentHash = window.location.hash.substring(1);
          if (currentHash === 'info') {
            switchTab('vcard', false);
          } else if (currentHash === 'qr' || currentHash === '') {
            switchTab('qr', false);
          }
        });
      });
    }
  };
})(Drupal);